/**
 * Active `sorted collections of definitions` go here:
 * 
 *  FormDefs, RecordDefs, ListDefs, ReportDefs
 * 
 * All of them use the `active` prefix to indicate a Store.
*/
import { writable } from 'svelte/store'

export let activeReportDefs = writable([])

activeReportDefs.subscribe((collection) => {

  let sorted = collection.sort((a, b) => {
    return a.title.localeCompare(b.title);
  })
  
  return sorted;
})
